module.exports = __webpack_public_path__ + "media/product/i-2-260c953d.png";